export default function showStoryDialog() {
    const overlay = document.getElementById('storyDialogOverlay')
    const content = document.getElementById('storyDialogContent')
    const closeBtn = document.getElementById('storyCloseBtn')
    const nextBtn = document.getElementById('storyNextBtn')
    const prevBtn = document.getElementById('storyPrevBtn')

    const dialog = [
        {
        person: 'Einführung',
        text: 'Alle sprechen von LLMs, Large Language Model, aber was ist das eigentlich? \n Hier gibt es eine Geschichte dazu sprachmodell sowie ihre Stärken als auch ihre Schwächen.',
        image: null,
        audio: null
        },
        {
            person: 'person1',
            text: 'Sie können sich ein LLM als einen unglaublich intelligenten Papagei vorstellen. Er hat unzählige Bücher gelesen und hat Menschen beim Reden zugehört. Er kann Sätze nachahmen, zusammenfügen und sogar die verschiedenen Intonationen der bisherigen Sprecher*innen wiedergeben. Dabei klingt der Papagei sehr überzeugend! \nAber was ist mit dem Papagei? \nVersteht er wirklich, was er da gesagt hat? \nHat er eigene Meinungen? \nWas passiert, wenn er etwas Falsches gehört hat? \nWie sie sehen, hat der Papagei Limitationen, die unterschiedlicher Natur sind. Wir wollen Ihnen nun einen Einblick in die Funktionsweise und den Limitationen von Sprachmodellen geben.Funktionsweise von  LLMs, Der Papagei liest das ganze Internet! Der Papagei sitzt vor einem riesigen Berg von Büchern, Zeitungen und Webseiten. Er liest sich alles durch und nimmt die Informationen auf. ',
            image: './audios/senior.png',
            audio: '/audios/KI-Limitationen_FinalVersion1.mp3'
        },
        {
            person: 'person2',
            text: ['*Papagei liest*\n ',
                  '*Papagei denkt über * Gelesenes nach…*\n',
                  '„Der Himmel ist…“\n',
                  '„Kaffee am…“\n',
                  '„Katze miaut, Hund…“'],
            image: './audios/papagai.png',
            audio: '/audios/KI-Limitationen_FinalVersion2.mp3'
        },
        {
            person: 'person3',
            text: '„Wow, der lernt ja alles auf einmal!“\n„Sag mal Papagei, \nkönntest du mir bitte eine Geschichte über eine mutige Prinzessin und einen sprechenden Drachen erzählen?“',
            image: './audios/dame.png',
            audio: '/audios/KI-Limitationen_FinalVersion3.mp3'
        },
        {
            person: 'person2',
            text: '*Papagei denkt*\n„Aha, Prinzessin, mutig, Drache, sprechen…“\n„Welche Wörter kommen nach Prinzessin und Drachen in Geschichten?“\nAh, ich habs…! ',
            image: './audios/papagai.png',
            audio: '/audios/KI-Limitationen_FinalVersion4.mp3'
        },
        {
            person: 'person1',
            text: '„?!“\n„Na nu, was ist denn hier passiert? Was hat der Papagei da gerade gemacht? Wissen Sie es zufällig?“\n„Zunächst einmal hat er denn Text in kleinere Teile zerlegt – das nennt man auch Tokenisierung. Ein Token wird im Deutschen auch als „Zeichen“ übersetzt. Hier ist es eine Folge zusammengehöriger Zeichen“\n„Es gibt unterschiedliche Techniken, um Wörter in Token herunterzubrechen. Von der Verwendung einzelner Zeichen bis hin zu ganzen Wörtern.“\n„Sag mal Papagei“ – könnten wir hier z.B. in drei Token umwandeln, aber auch in fünf, wenn man das Wort Papagei in weitere Teile zerlegt. ',
            image: './audios/senior.png',
            audio: '/audios/KI-Limitationen_FinalVersion6.mp3'
        },
        {
            person: 'person2',
            text: '„Einst lebte in einem fernen Land…“\n„… eine mutige Prinzessin namens Elza…“\n„… die eines Tages einen sprechenden Drachen traf.“\n„Der Drache, war alt und weise…“',
            image: './audios/papagai.png',
            audio: '/audios/KI-Limitationen_FinalVersion7.mp3'
        },
        {
            person: 'person3',
            text: '„Das klingt ja super! Aber wie hat du die einzelnen Wörter wieder zusammengefügt? ',
            image: './audios/dame.png',
            audio: '/audios/KI-Limitationen_FinalVersion8.mp3'
        },
        {
            person: 'person1',
            text:'„Eine sehr gute Frage!“ \n„Im nächsten Schritt kommt es zum sogenannten Embedding, auch Einbettung genannt. Hierbei werden Token auf Vektoren abgebildet. Aber was genau, war nochmal ein Vektor? Das können Sie sich ganz leicht vorstellen. Es ist wie eine Liste von Zahlen, die aber in einer bestimmten Reihenfolge steht und Zahlen in der Liste einen bestimmten „Wert“ repräsentieren. Jetzt sind die Vektoren aber nicht nur zwei oder drei Zahlen, sondern Hunderte oder gar Tausende an Werten lang.“\n„Die Idee ist also, jedes Wort in einen Vektor umzuwandeln, und zwar so, dass Wörter mit ähnlicher Bedeutung auch ähnliche Werte erhalten. Um Ihnen ein Beispiel zu geben, nehmen wir die Eltern von Prinzessin Elza – den König und die Königin. Zwei recht ähnliche Wörter, die nun als Vektoren z.B. die Werte [0.8, -0.2, 0.5] und [0.7, -0.1, 0.5] haben könnten.“\n„Um jetzt die Vorhersage zu treffen, welche Wörter aneinandergereiht werden, Bedarf es der Berechnung der Wahrscheinlichkeit des nächsten Tokens. Dies ist quasi der Kern der Sprachmodelle – Wahrscheinlichkeitsrechnung. Hierbei kann man unterschiedliche Techniken verwenden. Früher waren das noch simplere Berechnungen, wobei heutzutage vielschichtige neuronale Netze verwendet werden. Dabei fließen verschiedene Berechnungen in den ganzen Prozess ein, um am Ende ein Ergebnis geliefert zu bekommen.“\n„Nachdem wir nun die Wahrscheinlichkeiten haben, müssen diese auch wieder in Text umgewandelt werden, was sich auch Dekodierung nennt. So wie in den vorherigen Stufen auch, gibt es hier verschiedene Strategien. Man könnte z.B. immer das wahrscheinlichste Token auswählen oder die Wahrscheinlichkeiten der Top-3 Möglichkeiten im Auge behalten.“\n„So könnte ein Satz mit:\n„Der…“ beginnen – was würde nun als Nächstes kommen?“ „Hund, Weg, Baum“?\n„Die Wahrscheinlichkeiten für die Sätze:\n„Der Hund…“\n„Der Weg…“\n„Der Baum…“ \nwerden nun weiter betrachtet und die Wahrscheinlichkeiten für die nächstmöglichen Token werden weiter berechnet. Am Ende des Prozesses könnten die Sätze:\n„Der Hund rennt weg.“\n„Der Weg ist sehr lang.“\n„Der Baum wächst weiter.“\nstehen. Jetzt könnte der Satz ausgewählt werden, der über alle Schritte hinweg die höchste Wahrscheinlichkeit hatte.“\n„Wie Sie sehen, gibt es viele verschiedene Techniken bei der Wahrscheinlichkeitsrechnung, die alle unterschiedliche Ergebnisse aufweisen.“\n Limitation von LLMs, ich verstehe es nicht wirklich.',
            image: './audios/senior.png',
            audio: '/audios/KI-Limitationen_FinalVersion9.mp3'
        },
        {
            person: 'person3',
            text: 'Das klingt ja alles ganz toll. Aber hat er das wirklich alles verstanden?\n Papagei, wie fühlt sich ein Drache, wenn er traurig ist?',
            image: './audios/dame.png',
            audio: '/audios/KI-Limitationen_FinalVersion10.mp3'
        },
        {
            person: 'person2',
            text: '„*Papagai Schaut verwirrt um ihn herum. Er hat keine Informationen zu „Gefühlen von Drachen“*\n*Papagei denkt*\n„Uhm, …Drache, traurig … Worte wie allein, trübselig…“\n„Ich kann die Wörter zu Traurigkeit aneinanderreihen, aber nicht, wie es sich anfühlt.“',
            image: './audios/papagai.png',
            audio: '/audios/KI-Limitationen_FinalVersion11.mp3'
        },
        {
            person: 'person3',
            text: '„Okay, aber sag mal: Du bist doch um die ganze Welt geflogen. Die Menschen meinten früher, dass die Erde flach sei. Das stimmt doch nicht, oder?“',
            image: './audios/dame.png',
            audio: '/audios/KI-Limitationen_FinalVersion12.mp3'
        },
        {
            person: 'person2',
            text: '„In alten Texten steht ‚flach‘… in neuen Texten steht ‚Kugel‘ und ‚rund‘…“\n„Ich gebe dir die wahrscheinlichste Kombination von Wörtern, die ich gelernt habe, auch wenn sie manchmal falsch ist.“ \n„Das stimmt nicht. Ich bin fest davon überzeugt!“',
            image: './audios/papagai.png',
            audio: '/audios/KI-Limitationen_FinalVersion13.mp3'
        },
        {
            person: 'person3',
            text: '„Ok, danke dir…“\n„Jetzt habe ich noch eine letzte Bitte an dich. Ich brauche Hilfe bei meiner Erfindung. Ich brauche eine super duper innovative Erfindung, die es bisher noch nieeee gegeben hat. Kannst du mir da helfen?“',
            image: './audios/dame.png',
            audio: '/audios/KI-Limitationen_FinalVersion14.mp3'
        },
        {
            person: 'person2',
            text: '„Hmm, innovativ und Erfindung… ich kann dir bekannte Konzepte neu zusammenmischen. Aber wirklich etwas völlig Neues, was es noch nie gegeben hat?“\n„Das kann ich leider nicht. Ich kann nur Puzzleteile zusammensetzen, keine neuen Puzzleteile erfinden.“',
            image: './audios/papagai.png',
            audio: '/audios/KI-Limitationen_FinalVersion15.mp3'
        },
        {
            person: 'person1',
            text: 'Dieser Papagei ist wahrlich ein Meister der Sprachmuster und des Zusammenfügens von Wörtern. Schade, dass er kein echtes Verständnis aufweist und auch keine eigenen Meinungen wiedergeben kann. Fakten checken kann er leider auch nicht…\nNichts desto trotz ist ein Papagei doch recht hilfreich in bestimmten Fällen! ',
            image: './audios/senior.png',
            audio: '/audios/KI-Limitationen_FinalVersion16.mp3'
        }
        // ... insgesamt 16 Objekte
    ]

    let index = 0
    let currentAudio = null
  
    const playMessage = () => {
        const entry = dialog[index]
        if (!entry) return
    
        const msg = document.createElement('div')
        msg.className = `message ${entry.person}`
    
        // Avatar-Bild
        const avatar = document.createElement('img')
        avatar.className = 'avatar'
        avatar.src = entry.image
        avatar.alt = entry.person
    
        // Text
        const text = document.createElement('div')
        text.className = 'text'
        text.innerText = entry.text
    
        msg.appendChild(avatar)
        msg.appendChild(text)
        content.appendChild(msg)
        content.scrollTop = content.scrollHeight
    
        // Audio
        if (currentAudio) {
            currentAudio.pause()
            currentAudio.currentTime = 0
        }
    
        currentAudio = new Audio(entry.audio)
        currentAudio.play().catch(err => {
            console.warn('Audio konnte nicht abgespielt werden:', err)
        })
    }
  
    nextBtn.onclick = () => {
      if (index < dialog.length) {
        playMessage()
        index++
      }
    }
  
    prevBtn.onclick = () => {
      if (index > 0) {
        index--
        content.removeChild(content.lastChild)
      }
    }
  
    closeBtn.onclick = () => {
      overlay.classList.add('hidden')
      if (currentAudio) currentAudio.pause()
      content.innerHTML = ''
      index = 0
    }
  
    overlay.classList.remove('hidden')
    playMessage()
    index++
  }